<script>
export default {
    name: "DepositReceivedPrint",

    data() {

        return {
            payments: [],
        };
    },

    mounted() {

        this.fetchReceivedPayments().then(() => {
            window.print();
            window.onafterprint = function() { window.close(); }
        }).catch(() => {});
    },

    methods: {

        fetchReceivedPayments() {
            if(!this.$route.query.dateFrom && !this.$route.query.dateTo) return Promise.reject();
            let url = `AccountsReports/GetReceivedPayments?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            return this.$http.get(url).then(response => {
                this.payments = response.data;
            }).catch(() => {});
        },
    }
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full text-center my-2">
            <h5 class="font-bold text-base">Deposits Received Report</h5>
        </div>
        <table class="table table-bordered">
            <thead class="text-xs">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/6">Date</th>
                      <th class="p-tiny w-1/6">Patient</th>
                      <th class="p-tiny w-1/12">IPFile No</th>
                      <th class="p-tiny w-1/12">OPFile No</th>
                      <th class="p-tiny w-1/12">Receipt No</th>
                      <th class="p-tiny w-1/12">Type</th>
                      <th class="p-tiny w-1/12">Mode</th>
                      <th class="p-tiny w-1/12">User</th>
                      <th class="p-tiny w-1/12">Amount</th>
                      <th class="p-tiny w-1/12">Allocated</th>
                      <th class="p-tiny w-1/12">Un-allocated</th>
                  </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(payment, idx) in payments.depositsReport" :key="idx">
                    <td class="p-tiny w-1/6">{{ payment.trxDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ payment.names }}</td>
                    <td class="p-tiny w-1/12">{{ payment.ipfileno }}</td>
                    <td class="p-tiny w-1/12">{{ payment.opfileno }}</td>
                    <td class="p-tiny w-1/12">{{ payment.receiptNo }}</td>
                    <td class="p-tiny w-1/12">{{ payment.paymentType }}</td>
                    <td class="p-tiny w-1/12">{{ payment.mode }}</td>
                    <td class="p-tiny w-1/12">{{ payment.userName || `-` }}</td>
                    <td class="p-tiny w-1/12">{{ payment.depositAmount | numberFormat }}</td>
                    <td class="p-tiny w-1/12">{{ payment.amountAllocated | numberFormat }}</td>
                    <td class="p-tiny w-1/12">{{ payment.unAllocatedAmount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>